import { UnifiedAtonItem } from '../useUnifiedAtons';
import { VirtualAtonItem } from './VirtualAtonItem';
import { AtoNDefinition } from '@ais-ui/api-spec/config';
import { PhysicalAtonItem } from './PhysicalAtonItem';
import { HostAtonItem } from './HostAtonItem';
import { AtoNDefinitionWithDate, AtonHost } from '@ais-ui/api';

interface AtonItemProps {
  aton: UnifiedAtonItem;
  requiresMap: boolean;
}

export const AtonItem = ({ aton, requiresMap }: AtonItemProps) => {
  if (aton.type === 'virtual') {
    return (
      <VirtualAtonItem
        aton={aton.originalData as AtoNDefinitionWithDate}
        requiresMap={requiresMap}
      />
    );
  } else if (aton.type === 'physical') {
    return (
      <PhysicalAtonItem
        aton={aton.originalData as AtoNDefinitionWithDate}
        requiresMap={requiresMap}
      ></PhysicalAtonItem>
    );
  } else if (aton.type === 'synthetic') {
    return (
      <VirtualAtonItem
        aton={aton.originalData as AtoNDefinitionWithDate}
        requiresMap={requiresMap}
      />
    );
  } else if (aton.type === 'host') {
    return (
      <HostAtonItem
        aton={aton.originalData as AtonHost}
        requiresMap={requiresMap}
      ></HostAtonItem>
    );
  }

  return null;
};
